import Style from 'ol/style/Style';
import CircleStyle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import { StyleFunction } from 'ol/style/Style';

export class PointStyle {

  public getPointStyle(color: string, radius: number): Style {
    return new Style({
      image: new CircleStyle({
        radius,
        fill: new Fill({ color }),
        stroke: new Stroke({ color })
      })
    });
  }

  /**
   * Returns an OpenLayers StyleFunction.
   * You can tweak radius logic based on resolution if needed.
   */
  public getPointStyleByResolution(): StyleFunction {
    return (feature, resolution) => {
      // Example: scale radius with zoom/resolution (customize as you like)
      const r = 10; // or: Math.max(4, Math.min(16, 200 / resolution));

      return [
        new Style({
          stroke: new Stroke({
            color: '#567a60',
            width: 3
          }),
          fill: new Fill({
            color: '#28d658'
          }),
          image: new CircleStyle({
            radius: r,
            fill: new Fill({
              color: 'rgba(255, 0, 0, 0.1)'
            }),
            stroke: new Stroke({
              color: '#d67928',
              width: 2
            })
          })
        })
      ];
    };
  }
}
